import LMImagesReducer, { EngineImagesState } from 'features/Dealers/Listings/Images/state/reducer';
import dealerEngineReducer, { DealerEnginePreviewState } from 'features/Dealers/Listings/GMBPreview/state/reducer';
import dealerCMSReducer, { DealerInfoState } from "features/Dealers/Listings/Info/state/reducer";
import dealerLMReducer from "features/Dealers/Listings/Data/state/reducer";
import LMCategoriesReducer from "features/Dealers/Listings/Categories/state/reducer";
import LMSpecialHoursReducer from "features/Dealers/Listings/SpecialHours/state/reducer";
import LMOperationHoursReducer from "features/Dealers/Listings/OperationHours/state/reducer";
import LMKeywordsReducer from "features/Dealers/Listings/Keywords/state/reducer";
import { DealerLMState } from 'features/Dealers/Listings/Data/state/reducer';
import { EngineCategoryState } from 'features/Dealers/Listings/Categories/state/reducer';
import { EngineSpecialHourState } from 'features/Dealers/Listings/SpecialHours/state/reducer';
import { EngineKeywordState } from 'features/Dealers/Listings/Keywords/state/reducer';
import { Action, combineReducers } from 'redux';
import { ChangedInfoUI, ListingType, ListingUI, LMValidation } from 'features/Dealers/Listings/state/types';
import { ListingSyncErrorsUI } from 'features/Dealers/Listings/state/types';
import { DealerListingsWithErrorsUI } from 'features/Dealers/Listings/state/types';
import { ActionGetListingSyncErrorsRequestSuccess } from 'features/Dealers/Listings/state/actions';
import { ActionGetDealerListingsWithErrorsRequestSuccess } from 'features/Dealers/Listings/state/actions';
import { ActionEditCurrentSelectedListing, ActionGetListingsForDealerRequest, ActionGetListingsForDealerRequestSuccess, ActionListingsChangesRequestSuccess } from 'features/Dealers/Listings/state/actions';
import * as ACTIONS from "./actionTypes";
import * as DEPARTMENT_ACTIONS from "../../DealerConfiguration/Departments/state/actionTypes";
import * as LMDATA_ACTIONS from "../Data/state/actionTypes";
import _, { has } from 'lodash';
import { ActionPostListingSuccess } from 'features/Dealers/DealerConfiguration/Departments/state/actions';
import { ActionGetLMValidationAPISuccess } from 'features/Dealers/Listings/state/actions';
import { EngineOperationHourState } from '../OperationHours/state/reducer';

export interface SingleListingState {
    data: DealerLMState,
    categories: EngineCategoryState,
    operationHours: EngineOperationHourState,
    specialHoursData: EngineSpecialHourState,    
    keywordsData: EngineKeywordState,
    images: EngineImagesState
    info: DealerInfoState
    enginePreview: DealerEnginePreviewState,
}

export interface ListingByDealerState {
    [x: string]: ListingUI[]
}

export interface ListingById {
    [x: string]: ListingUI
}


export interface ListingInternalState {
    byDealerId: ListingByDealerState,
    byListingId: ListingById
    selectedListingId?: string
    listingSyncErrors?: ListingSyncErrorsUI
    listingsChanges?: ChangedInfoUI
    syncErrors?: DealerListingsWithErrorsUI[]
    lmValidation?: LMValidation
}


export interface ListingState {
    currentListing: SingleListingState,
    listings: ListingInternalState
}

const defaultState: ListingInternalState = {
    byDealerId: {},
    byListingId: {},
    syncErrors: undefined,
    lmValidation: undefined,
    listingSyncErrors: undefined
   
}

const singleListingReducer = combineReducers<SingleListingState>({
    data: dealerLMReducer,
    categories: LMCategoriesReducer,
    operationHours: LMOperationHoursReducer,
    specialHoursData: LMSpecialHoursReducer,
    keywordsData: LMKeywordsReducer,
    images: LMImagesReducer,
    info: dealerCMSReducer,
    enginePreview: dealerEngineReducer,
})


type ListingActions = ActionGetListingsForDealerRequestSuccess | ActionEditCurrentSelectedListing | ActionGetListingSyncErrorsRequestSuccess | ActionListingsChangesRequestSuccess | ActionGetDealerListingsWithErrorsRequestSuccess;

function listingInternalReducer(state: ListingInternalState = defaultState, action: ListingActions): ListingInternalState {
    switch (action.type) {
        case ACTIONS.USECHATMETERLOCATION_API_SUCCESS: {
            const {listings} = (action as ActionGetListingsForDealerRequestSuccess);
            const listingsByDealerId = _.groupBy(listings, 'dealerId')
            const byDealerId = {
                ...state.byDealerId,
                ...listingsByDealerId,                
            }
            return {
                ...state,
                byDealerId

            }
        }
        case ACTIONS.GET_LISTINGS_CHANGES_API_SUCCESS:{
            const {listingsChanges} = (action as ActionListingsChangesRequestSuccess);
            return {
                ...state,
                listingsChanges: listingsChanges
            }
        }
        case ACTIONS.CLEAR_LISTINGS_CHANGES: {
            return {
                ...state,
                listingsChanges: undefined
            }
        }
        case ACTIONS.GET_LISTINGS_FOR_DEALER_API_SUCCESS: {
            const {listings} = (action as ActionGetListingsForDealerRequestSuccess);

            const listingsByDealerId = _.groupBy(listings, 'dealerId')
            const byDealerId = {
                ...state.byDealerId,
                ...listingsByDealerId,                
            }
            return {
                ...state,
                byDealerId

            }
        }
        case ACTIONS.EDIT_CURRENT_SELECTED_LISTING: {
            const listingId = (action as ActionEditCurrentSelectedListing).listingId
            return {
                ...state,
                selectedListingId: listingId
            }
        }
        case ACTIONS.GET_LISTING_SYNC_ERRORS_API_SUCCESS: {
            return {
                ...state,
                listingSyncErrors: (action as ActionGetListingSyncErrorsRequestSuccess).listingSyncErrors,
            }
        }
        case ACTIONS.GET_DEALER_LISTINGS_WITH_ERRORS_API_SUCCESS: {
            return {
                ...state,
                syncErrors: (action as ActionGetDealerListingsWithErrorsRequestSuccess).syncErrors,
            }
        }
        case ACTIONS.GET_LMVALIDATION_API_SUCCESS: {
            const lmValidation = (action as ActionGetLMValidationAPISuccess).lmValidation
            return {
                ...state,
                lmValidation: lmValidation
            }
        }            
        case DEPARTMENT_ACTIONS.POST_LISTINGS_API_SUCCESS: {
            const { listings } = (action as ActionPostListingSuccess);
            const dealerId = listings.length > 0 ? listings[0].dealerId : undefined
            if (dealerId) {
                const listingsForDealer = state.byDealerId[dealerId];
                const primaryListing = listingsForDealer?.filter(l => l.type === ListingType.PRIMARY) ?? [];
                const departmentListings = listings.filter(f=> f.id !== null && f.idInSource !==null)                
                const listingsByDealerId = _.groupBy([ ...primaryListing, ...departmentListings], 'dealerId')
                const byDealerId = {
                    ...state.byDealerId,
                    ...listingsByDealerId
                }
                return {
                    ...state,
                    byDealerId,


                }
            }

        }        
    }
    return { ...state, }

}

const listingReducer = combineReducers<ListingState>({
    currentListing: singleListingReducer,
    listings: listingInternalReducer
})

export default listingReducer;


